
// **************************** Community Events Email Contact Form ****************************** //

const submitButton = document.getElementById("submitButton");

const scriptURL = "https://script.google.com/macros/s/AKfycbyeyuD8NIDoYy5IkOAXSwBQ1QmQ6sXm05h1qevQK4CFYD1UD6RQZ94zCuxDN-cL-IMS/exec";

const form = document.forms["asattc-event-signup"];

const firstName = document.getElementById('firstName');

const lastName = document.getElementById('lastName');

const email = document.getElementById('email');

// Get the modal
var emailModal = document.getElementById("emailModal");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("modalClose")[0];

const modalHeading = document.getElementById("modal-heading");

const modalText = document.getElementById("modal-text");


submitButton.addEventListener('click', e => {
    
  e.preventDefault()

  // showSpinner()

  const formData = new FormData(form);

  // console.log('First Name:', firstName.value);

  // console.log('Last Name:', lastName.value);

  // console.log('Email:', email.value);


  if (firstName.value.trim() == null || firstName.value.trim() == '') {

    // hideSpinner()

    emailModal.style.display = "block";

    modalHeading.innerHTML = `Oops!`;

    modalText.innerHTML = `Please enter your first name.`;

    span.onclick = function() {
      emailModal.style.display = "none";
      modalHeading.innerHTML = ``;
      modalText.innerHTML = ``;
    }

  }


  else if (lastName.value.trim() == null || lastName.value.trim() == '') {

    // hideSpinner()

    emailModal.style.display = "block";

    modalHeading.innerHTML = `Oops!`;

    modalText.innerHTML = `Please enter your last name.`;

    span.onclick = function() {
      emailModal.style.display = "none";
      modalHeading.innerHTML = ``;
      modalText.innerHTML = ``;
    }
  }


  else if (email.value.trim() == null || email.value.trim() == '') {

    // hideSpinner()

    emailModal.style.display = "block";

    modalHeading.innerHTML = `Oops!`;

    modalText.innerHTML = `Please enter your email.`;

    span.onclick = function() {
      emailModal.style.display = "none";
      modalHeading.innerHTML = ``;
      modalText.innerHTML = ``;
    }
  }

  
  else if (email.value.trim() != null) {

    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email.value.trim())) {

      submitEventRequest(formData); 

    }
  }

});


function submitEventRequest(formData) {

  submitButton.disabled = true;
  submitButton.value = "Submitting...";

  fetch(scriptURL, { method: "POST", body: formData })
    .then((response) => response.json())
    .then ((result) =>  { 

      // console.log('Submission Result:', result.result);
      // console.log('data:', result.data);

      var errorMessage = "";

      if (result.result == 'success') {
      
        submitButton.disabled = false;
        submitButton.value = "Thank you!";

        emailModal.style.display = "block";
    
        modalHeading.innerHTML = `Thank you for submitting!`;

        span.onclick = function() {
          emailModal.style.display = "none";
          modalHeading.innerHTML = ``;
          modalText.innerHTML = ``;
          form.reset();
          submitButton.value = "Submit";
        }
       
      }

      if (result.result == 'error') {

       // console.log('Submission Result:', result.result.e);

        emailModal.style.display = "block";

        modalHeading.innerHTML = `Oops!`;

        modalText.innerHTML = `Something went wrong.<br>Please try again.`;

        span.onclick = function() {
          emailModal.style.display = "none";
          modalHeading.innerHTML = ``;
          modalText.innerHTML = ``;
          form.reset();
          submitButton.disabled = false;
          submitButton.value = "Submit";
        }
        
    }
  })
    .catch(error => { 

      emailModal.style.display = "block";

      modalHeading.innerHTML = `Oops!`;

      modalText.innerHTML = `Something went wrong.<br>Please try again.`;

      span.onclick = function() {
        emailModal.style.display = "none";
        modalHeading.innerHTML = ``;
        modalText.innerHTML = ``;
        form.reset();
        submitButton.disabled = false;
        submitButton.value = "Submit";
      }

  });
}


  function showSpinner() {
    document.getElementById('spinner')
            .style.display = 'block';

    document.getElementById('submit-text')
            .style.display = 'none';
} 

function hideSpinner() {
    document.getElementById('spinner')
            .style.display = 'none';

    document.getElementById('submit-text')
            .style.display = 'block';
} 

